<template>
    <div v-on-clickaway="closeMenu" :class="collapsed ? 'w-full flex justify-center' : ''" class="relative">
        <button
            id="sidebar-user-menu"
            type="button"
            aria-label="User menu"
            aria-haspopup="true"
            :class="buttonClass"
            @click="dropdownOpen = !dropdownOpen"
        >
            <span :class="['sidebar-user-avatar-slot', collapsed ? 'sidebar-user-avatar-slot-collapsed' : '']">
                <img :src="avatarSrc" alt="User avatar" class="h-9 w-9 rounded-full"/>
            </span>
            <div :class="['sidebar-user-meta', collapsed ? 'sidebar-user-meta-hidden' : '']">
                <div class="text-sm leading-5 font-medium truncate text-white">{{ $store.state.user.name }}</div>
                <div class="text-xs leading-4 truncate text-gray-400">{{ $store.state.user.email }}</div>
            </div>
        </button>

        <transition
            duration="120"
            enter-active-class="transition ease-out duration-100"
            enter-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <div
                v-show="dropdownOpen"
                :class="dropdownClass"
            >
                <div aria-labelledby="sidebar-user-menu" aria-orientation="vertical" class="stage-dropdown-menu rounded bg-white shadow-xs" role="menu">
                    <div class="flex items-center px-4 py-2 border-b border-bordergray-100">
                        <img :src="avatarSrc" alt="User avatar" class="h-8 w-8 mr-3 align-middle rounded-full"/>
                        <div class="w-40">
                            <div class="text-sm font-medium truncate text-gray-800">{{ $store.state.user.name }}</div>
                            <div class="text-xs truncate text-gray-500">{{ $store.state.user.email }}</div>
                        </div>
                    </div>

                    <router-link
                        class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition ease-in-out duration-150"
                        role="menuitem"
                        to="/account"
                        @click="dropdownOpen = false"
                    >
                        {{ $t('Account settings') }}
                    </router-link>
                    <legal-links-menu
                        link-class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition ease-in-out duration-150"
                        @link-click="dropdownOpen = false"
                    />

                    <a
                        class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition ease-in-out duration-150"
                        href="/auth/logout"
                        role="menuitem"
                        @click.prevent="signOut"
                    >
                        {{ $t('Sign out') }}
                    </a>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import {mixin as clickaway} from "vue-clickaway";
import LegalLinksMenu from "@/components/shared/legal-links-menu";

export default {
    name: "sidebar-user-menu",
    components: {LegalLinksMenu},
    mixins: [clickaway],
    props: {
        collapsed: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data() {
        return {
            dropdownOpen: false,
        };
    },
    computed: {
        buttonClass() {
            if (this.collapsed) {
                return 'sidebar-user-trigger sidebar-user-trigger-collapsed';
            }

            return 'sidebar-user-trigger';
        },
        dropdownClass() {
            if (this.collapsed) {
                return 'origin-bottom-left absolute left-[30px] bottom-full mb-2 w-56 rounded shadow-lg z-[220]';
            }

            return 'origin-bottom-left absolute left-0 bottom-full mb-2 w-56 rounded shadow-lg z-[220]';
        },
        avatarSrc() {
            const user = (this.$store && this.$store.state && this.$store.state.user) ? this.$store.state.user : {};
            return user.avatar === 'gravatar' ? user.gravatar : (user.avatar || '');
        }
    },
    methods: {
        signOut() {
            this.dropdownOpen = false;
            this.$store.commit('logout');
            this.$router.push('/auth/login');
        },
        closeMenu() {
            this.dropdownOpen = false;
        }
    }
}
</script>
